import type { VoltexploitI18nOptions } from "~ui/@application/configs/i18n-config.ts";

import { createTypedIntl } from "@voltalis/frontend-tooling/i18n/runtime";
import { useI18n } from "vue-i18n";
import { keys } from "~ui/@application/locales/.generated/i18n-keys.generated.ts";

export function useTypesafeI18n() {
  const i18n = useI18n<typeof VoltexploitI18nOptions>();

  return {
    ...i18n,
    bool(bool?: boolean | null) {
      if (bool) {
        return i18n.t("common.misc.yes");
      }

      return i18n.t("common.misc.no");
    },
  };
}

const useTypedIntl = createTypedIntl(keys);

export function useTypedI18n() {
  const intl = useTypedIntl();

  return {
    ...intl,
    bool(bool?: boolean | null) {
      if (bool) {
        return intl.rawT("common.misc.yes");
      }

      return intl.rawT("common.misc.no");
    },
  };
}
